import styled from 'styled-components';
import { ApModal } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
  .ap-modal-wrapper {
    overflow: hidden;
  }

  .ap-modal-content {
    max-width: 560px;
    max-height: 100%;
  }

  .ap-modal-header {
    border: none;
    padding: 8px 16px 16px 32px;

    h4 {
      font-weight: 500;
      font-size: 23px;
      line-height: 31px;
      letter-spacing: 0.3px;
      padding-top: 8px;
    }

    .ap-button-icon {
      align-self: flex-start;
    }
  }

  .ap-modal-body {
    padding: 16px 32px 32px;
    line-height: 24px;
    display: flex;
    flex-direction: column;
  }

  .ap-modal-footer {
    padding: 8px 32px;
  }
`;

export const TextContent = styled.div`
  white-space: pre-line;
`;

export const ProvidersList = styled.ul``;
export const ProviderItem = styled.li`
  list-style: circle;
  font-weight: bold;
  font-size: 16px;
`;
